import { useCallback } from 'react';

export default function TargetSection() {
  const targets = [
    {
      icon: 'ri-user-star-line',
      title: 'ホストの方へ',
      description: 'シャンパンコールで一気に場を盛り上げる、あなただけのオリジナルボトル',
      image: 'https://public.readdy.ai/ai/img_res/edited_8918b96b484c232037f646a17e7fd789_0e707280.jpg',
      tabKey: 'host',
      imgPosition: 'object-top',
    },
    {
      icon: 'ri-user-heart-line',
      title: 'キャバ嬢の方へ',
      description: 'SNS映えするオリシャンで、フォロワー増加＆指名率アップを狙う',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20hostess%20holding%20a%20sparkling%20LED%20champagne%20bottle%2C%20glamorous%20evening%20dress%2C%20beautiful%20smile%2C%20luxury%20VIP%20lounge%20setting%2C%20professional%20photography%2C%20soft%20purple%20and%20gold%20lighting%2C%20sophisticated%20atmosphere%2C%20high-end%20nightlife%20scene&width=600&height=800&seq=target-cabaret-001&orientation=portrait',
      tabKey: 'cabaret',
      imgPosition: 'object-[center_20%]',
    },
    {
      icon: 'ri-store-3-line',
      title: 'BARオーナーの方へ',
      description: '店舗ロゴ入りオリシャンで、VIPゲストの記念日を彩る',
      image: 'https://static.readdy.ai/image/58a7675dc513598d46eb82051fde6608/90d12c92820481027b1820fbbf66c469.png',
      tabKey: 'logo',
      imgPosition: 'object-center',
    },
  ];

  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, tabKey: string) => {
    e.preventDefault();
    // タブを設定してからスクロール
    window.location.hash = `achievements?tab=${tabKey}`;
    setTimeout(() => {
      const el = document.getElementById('achievements');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 50);
  }, []);

  return (
    <section className="py-8 md:py-24 bg-gradient-to-b from-purple-950/20 to-black">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-white mb-10 md:mb-16">
          あなたのビジネスを<span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200">輝かせる</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {targets.map((target, index) => (
            <a
              key={index}
              href={`#achievements?tab=${target.tabKey}`}
              onClick={(e) => handleClick(e, target.tabKey)}
              className="group bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl overflow-hidden border border-purple-500/20 hover:border-yellow-400/50 transition-all duration-500 hover:scale-105 cursor-pointer block"
            >
              <div className="relative h-56 md:h-80 overflow-hidden">
                <img
                  src={target.image}
                  alt={target.title}
                  className={`w-full h-full object-cover ${target.imgPosition} group-hover:scale-110 transition-transform duration-700`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
              </div>
              <div className="p-6 md:p-8">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-2xl flex items-center justify-center mb-4 md:mb-6 shadow-lg">
                  <i className={`${target.icon} text-2xl md:text-3xl text-black`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4">{target.title}</h3>
                <p className="text-gray-300 leading-relaxed text-sm md:text-base">{target.description}</p>
                <div className="mt-4 md:mt-6 flex items-center gap-2 text-yellow-400 font-semibold">
                  <span>詳しく見る</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
